import { render } from "./QrDropzone.vue?vue&type=template&id=6daecc35&bindings={\"worker\":\"props\",\"onDrop\":\"setup\",\"onDragOver\":\"setup\"}"
import script from "./QrDropzone.vue?vue&type=script&lang=ts"
export * from "./QrDropzone.vue?vue&type=script&lang=ts"
script.render = render

export default script